var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarraPrata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 980,
    height: 20,
    viewBox: "0 0 980 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M312.654 20.001H0V0.000976562H318.959L312.654 20.001Z",
    fill: "#ADADAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M645.33 20.001H326.186L328.344 13.135L332.479 0.000976562H652.161L645.33 20.001Z",
    fill: "#ADADAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M663.392 20H660.792L667.08 0H669.68L663.392 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M668.59 20H665.99L672.278 0H674.878L668.59 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M673.789 20H671.189L677.477 0H680.077L673.789 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M678.987 20H676.387L682.675 0H685.275L678.987 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M684.186 20H681.586L687.874 0H690.474L684.186 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M689.384 20H686.784L693.072 0H695.672L689.384 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M694.583 20H691.983L698.271 0H700.871L694.583 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M699.781 20H697.181L703.469 0H706.069L699.781 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M704.98 20H702.38L708.668 0H711.268L704.98 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M710.178 20H707.578L713.866 0H716.466L710.178 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M715.377 20H712.777L719.065 0H721.665L715.377 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M720.575 20H717.975L724.263 0H726.863L720.575 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M725.774 20H723.174L729.462 0H732.062L725.774 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M730.972 20H728.372L734.66 0H737.26L730.972 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M736.171 20H733.571L739.859 0H742.459L736.171 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M741.369 20H738.769L745.057 0H747.657L741.369 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M746.568 20H743.968L750.256 0H752.856L746.568 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M751.766 20H749.166L755.454 0H758.054L751.766 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M756.965 20H754.365L760.653 0H763.253L756.965 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M762.163 20H759.563L765.851 0H768.451L762.163 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M767.362 20H764.762L771.05 0H773.65L767.362 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M772.56 20H769.96L776.248 0H778.848L772.56 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M777.759 20H775.159L781.447 0H784.047L777.759 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M782.957 20H780.357L786.645 0H789.245L782.957 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M788.156 20H785.556L791.844 0H794.444L788.156 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M793.354 20H790.754L797.042 0H799.642L793.354 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M798.553 20H795.953L802.241 0H804.841L798.553 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M803.75 20H801.15L807.438 0H810.038L803.75 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M808.95 20H806.35L812.638 0H815.238L808.95 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M814.148 20H811.548L817.836 0H820.436L814.148 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M819.347 20H816.747L823.035 0H825.635L819.347 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M824.545 20H821.945L828.233 0H830.833L824.545 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M829.744 20H827.144L833.432 0H836.032L829.744 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M834.942 20H832.342L838.63 0H841.23L834.942 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M840.141 20H837.541L843.829 0H846.429L840.141 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M845.339 20H842.739L849.027 0H851.627L845.339 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M850.537 20H847.938L854.226 0H856.825L850.537 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M855.736 20H853.136L859.424 0H862.024L855.736 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M860.935 20H858.335L864.623 0H867.223L860.935 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M866.133 20H863.533L869.821 0H872.421L866.133 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M871.332 20H868.732L875.02 0H877.62L871.332 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M876.53 20H873.93L880.218 0H882.818L876.53 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M881.729 20H879.129L885.417 0H888.017L881.729 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M886.927 20H884.327L890.615 0H893.215L886.927 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M892.125 20H889.525L895.813 0H898.413L892.125 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M897.325 20H894.725L901.013 0H903.613L897.325 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M902.523 20H899.923L906.211 0H908.811L902.523 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M907.721 20H905.121L911.409 0H914.009L907.721 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M912.92 20H910.32L916.608 0H919.208L912.92 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M918.118 20H915.518L921.806 0H924.406L918.118 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M923.317 20H920.717L927.005 0H929.605L923.317 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M928.515 20H925.915L932.203 0H934.803L928.515 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M933.714 20H931.114L937.402 0H940.002L933.714 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M938.912 20H936.312L942.6 0H945.2L938.912 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M944.111 20H941.511L947.799 0H950.399L944.111 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M949.309 20H946.709L952.997 0H955.597L949.309 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M954.508 20H951.908L958.196 0H960.796L954.508 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M959.706 20H957.106L963.394 0H965.994L959.706 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M964.905 20H962.305L968.593 0H971.193L964.905 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M970.103 20H967.503L973.791 0H976.391L970.103 19.994V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M975.302 19.997H972.702L973.862 16.308L978.989 0.00195312H979.747V5.85695L975.302 19.995V19.997Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M977.9 19.9962L979.748 13.6802V19.9962H977.9Z",
    fill: "#888888",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarraPrata);
export default __webpack_public_path__ + "static/media/barra-prata.cf99bdf78a227b99e8eca7b629a1d4d2.svg";
export { ForwardRef as ReactComponent };